import React, { useContext, useState, useRef } from "react";
import { AppContext } from "../../context/AppContext";
import { Link, useNavigate } from "react-router-dom";
import { Autocomplete } from "@react-google-maps/api";

function Main(props) {
  const {
    categories,
    brands,
    conditions,
    searchAds,
    searchMechanics,
    searchTowTrucks,
  } = useContext(AppContext);
  let navigate = useNavigate();
  const [activeModal, setActiveModal] = useState(null);
  const closeModal = () => setActiveModal(null);

  const [title, setTitle] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [category, setCategory] = React.useState("");
  const [condition, setCondition] = React.useState("");
  const [minPrice, setMinPrice] = React.useState("");
  const [maxPrice, setMaxPrice] = React.useState("");
  const [brand, setBrand] = React.useState("");
  const [brandModel, setBrandModel] = React.useState([]);
  const [brandModels, setBrandModels] = React.useState([]);

  const [coordinates, setCoordinates] = useState({
    lat: null,
    lng: null,
    state: "",
  });
  const autocompleteRef = useRef(null);
  const [address, setAddress] = useState("");
  const [specialty, setSpecialty] = useState("");
  const [capacity, setCapacity] = useState("");

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();

    if (place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      // Extract state from address_components
      let state = "";
      const addressComponents = place.address_components;
      if (addressComponents) {
        for (let comp of addressComponents) {
          if (comp.types.includes("administrative_area_level_1")) {
            state = comp.long_name;
            break;
          }
        }
      }

      setAddress(place.formatted_address);
      setCoordinates({ lat, lng, state });

      console.log("Selected:", {
        address: place.formatted_address,
        state,
        lat,
        lng,
      });
    }
  };

  return (
    <div className="main-hold">
      <div className="so_advanced_search">
        <div className="sas_inner-box-search">
          <div className="container m-container">
            <div className="row">
              <div className="col-md-6 sm-show">
                <div className="main-info">
                  <img src="/image/arrow.svg" />
                  <h1>Discover & buy your new car parts.</h1>
                  <p>Affordable & genuine everyday motor parts</p>
                  <div>
                    <img src="/image/appstore.svg" className="img2" />
                    <img src="/image/playstore.png" className="img2" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="main-info">
                  <h1>What are you looking for?</h1>
                  <div className="search-button three-buttons">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setActiveModal("mechanic")}
                    >
                      <img
                        src="/image/mechanic.png"
                        alt="Mechanic"
                        className="btn-icon"
                      />
                      Find Mechanic
                    </button>

                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => setActiveModal("parts")}
                    >
                      <img
                        src="/image/car-parts.png"
                        alt="Parts"
                        className="btn-icon"
                      />
                      Find Parts
                    </button>

                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={() => setActiveModal("towtruck")}
                    >
                      <img
                        src="/image/towtruck.png"
                        alt="Tow Truck"
                        className="btn-icon"
                      />
                      Find Tow Truck
                    </button>
                  </div>

                  {/* */}

                  {activeModal && (
                    <div className="custom-modal-overlay" onClick={closeModal}>
                      <div
                        className="custom-modal"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="custom-modal-header">
                          <h5
                            className="text-red"
                            style={{ color: "CaptionText" }}
                          >
                            {activeModal === "mechanic"
                              ? "Find a Mechanic"
                              : activeModal === "parts"
                              ? "Find a Part"
                              : "Find a Tow Truck"}
                          </h5>
                          <button className="close-btn" onClick={closeModal}>
                            ×
                          </button>
                        </div>

                        {/* mechanic form*/}

                        <div className="custom-modal-body">
                          {activeModal === "mechanic" && (
                            <div className="">
                              <div className="">
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    className="form-control grey-border-input"
                                    placeholder="e.g., Engine repair, AC, Electrical..."
                                    onChange={(event) =>
                                      setSpecialty(event.target.value)
                                    }
                                  />
                                </div>
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <Autocomplete
                                    onLoad={(autoC) =>
                                      (autocompleteRef.current = autoC)
                                    }
                                    onPlaceChanged={onPlaceChanged}
                                    className="overide"
                                  >
                                    <input
                                      name="address"
                                      type="text"
                                      placeholder="Where should the mechanic come?"
                                      className={[
                                        "form-control grey-border-input",
                                        //errors?.address ? " is-invalid" : "",
                                      ].join(" ")}
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                    />
                                  </Autocomplete>
                                </div>
                                <div className="search-button">
                                  <button
                                    type="button"
                                    id="sas_search_button0"
                                    onClick={() => {
                                      searchMechanics(
                                        specialty,
                                        address,
                                        coordinates?.lat,
                                        coordinates?.lng
                                      );
                                      navigate("../mechanics", {
                                        replace: true,
                                      });
                                    }}
                                  >
                                    Find A Mechanic
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* mechanic form*/}
                          {activeModal === "parts" && (
                            <div className="">
                              <div className="">
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    className="form-control grey-border-input"
                                    placeholder="Item name e.g fuel pump"
                                    onChange={(event) =>
                                      setTitle(event.target.value)
                                    }
                                  />
                                </div>

                                <div className="flexBox">
                                  <div
                                    className="search-boxes"
                                    style={{ width: "49%" }}
                                  >
                                    <input
                                      className="form-control grey-border-input"
                                      placeholder="Min price"
                                      onChange={(event) =>
                                        setMinPrice(event.target.value)
                                      }
                                    />
                                  </div>

                                  <div
                                    className="search-boxes"
                                    style={{ width: "49%" }}
                                  >
                                    <input
                                      className="form-control grey-border-input"
                                      placeholder="Max price"
                                      onChange={(event) =>
                                        setMaxPrice(event.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <select
                                    className="form-control grey-border-input"
                                    onChange={(event) =>
                                      setCategory(event.target.value)
                                    }
                                  >
                                    <option value="">
                                      --Select Category--
                                    </option>

                                    {categories?.map((value, index) => {
                                      return (
                                        <option key={index} value={value.id}>
                                          {value.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <select
                                    className="form-control grey-border-input"
                                    id="so_make0"
                                    onChange={(event) => {
                                      let obj = JSON.parse(event.target.value);
                                      setBrand(obj.id);
                                      setBrandModels(obj.brand_models);
                                    }}
                                  >
                                    <option value="">--Select Brand--</option>
                                    {brands?.map((value, index) => {
                                      return (
                                        <option
                                          key={index}
                                          value={JSON.stringify(value)}
                                        >
                                          {value.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                {brand != "" ? (
                                  <div
                                    className="search-boxes"
                                    style={{ width: "100%" }}
                                  >
                                    <select
                                      className="form-control grey-border-input"
                                      onChange={(event) => {
                                        setBrandModel(event.target.value);
                                      }}
                                    >
                                      <option value="">
                                        --Select Brand Model
                                      </option>
                                      {brand === "" ? (
                                        <option value="">
                                          Select brand first
                                        </option>
                                      ) : (
                                        <></>
                                      )}
                                      {brandModels?.map((value, index) => {
                                        return (
                                          <option key={index} value={value.id}>
                                            {value.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                ) : (
                                  <></>
                                )}
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <select
                                    className="form-control grey-border-input"
                                    value={condition}
                                    onChange={(event) => {
                                      setCondition(event.target.value);
                                    }}
                                  >
                                    <option value="">--Select Condition</option>
                                    =
                                    {conditions?.map((value, index) => {
                                      return (
                                        <option key={index} value={value.id}>
                                          {value.name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                <div className="search-button">
                                  <button
                                    type="button"
                                    id="sas_search_button0"
                                    onClick={() => {
                                      searchAds(
                                        category,
                                        brand,
                                        minPrice,
                                        maxPrice,
                                        title
                                      );
                                      navigate("../search", { replace: true });
                                    }}
                                  >
                                    Find My Part
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}

                          {activeModal === "towtruck" && (
                            <div className="">
                              <div className="">
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <input
                                    className="form-control grey-border-input"
                                    placeholder="e.g., 300lbs, truck capacity"
                                    onChange={(event) =>
                                      setCapacity(event.target.value)
                                    }
                                  />
                                </div>
                                <div
                                  className="search-boxes"
                                  style={{ width: "100%" }}
                                >
                                  <Autocomplete
                                    onLoad={(autoC) =>
                                      (autocompleteRef.current = autoC)
                                    }
                                    onPlaceChanged={onPlaceChanged}
                                    className="overide"
                                  >
                                    <input
                                      name="address"
                                      type="text"
                                      placeholder="Where should the tow truck come?"
                                      className={[
                                        "form-control grey-border-input",
                                        //errors?.address ? " is-invalid" : "",
                                      ].join(" ")}
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                    />
                                  </Autocomplete>
                                </div>
                                <div className="search-button">
                                  <button
                                    type="button"
                                    id="sas_search_button0"
                                    onClick={() => {
                                      searchTowTrucks(
                                        capacity,
                                        address,
                                        coordinates?.lat,
                                        coordinates?.lng
                                      );
                                      navigate("../towtrucks", {
                                        replace: true,
                                      });
                                    }}
                                  >
                                    Find A Tow Truck
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* modal*/}
                </div>
              </div>
              <div className="col-md-6 sm-no">
                <div className="main-info">
                  <img src="/image/arrow.svg" />
                  <h1>Discover & buy your new car parts.</h1>
                  <p>Affordable & genuine everyday motor parts</p>
                  <div>
                    <a
                      href="https://apps.apple.com/in/app/maine-auto-parts/id6474206760"
                      target="_blank"
                    >
                      <img src="/image/appstore.svg" className="img2" />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.maineautopartspro"
                      target="_blank"
                    >
                      <img src="/image/playstore.png" className="img2" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
